import { assignments, mapOnexVariant } from '@otto-ec/global-resources/onex'
import { OnexAssignmentsPort } from '../../../ports'
import { ActiveOnexConfig, OnexConfig, OnexId } from '@otto-ec/eprivacy-onex'

export const onexAssignmentsAdapter: OnexAssignmentsPort = async (
  onexId: OnexId,
  config: ActiveOnexConfig,
  defaultConfig: OnexConfig
) => {
  await new Promise((resolve) => {
    assignments.subscribe((onexData) => {
      if (onexData) {
        return resolve(undefined)
      }
    })
  })
  return mapOnexVariant(onexId, config, defaultConfig) as OnexConfig
}
